<template>
  <div class="col-12">
    <slot />
  </div>
</template>

<script>
import ExceptionMap from '../../exceptions/ExceptionMap';
const ApiService = require('../../services/ApiService');
const NotificationService = window.CeresNotification;

export default {

  name: 'MatrixVariations',

  data () {
    return {
      variationsToBuy: []
    };
  },

  mounted () {
    this.addEventHandler();
  },

  methods: {
    addEventHandler () {
      document.addEventListener('matrixVariationQuantityUpdated', data => {
        if (data.detail.variation && data.detail.variation.variationId) {
          this.updateQuantity(data.detail.qty, data.detail.variation);
        }
      });

      // document.dispatchEvent(new CustomEvent("matrixTriggerAddToBasket", {}));
      document.addEventListener('matrixTriggerAddToBasket', data => {
        this.addToBasket();
      });
    },

    updateQuantity (qty, variation) {
      if (!variation || !variation.variationId) {
        return;
      }
      const variationIndex = this.variationsToBuy.findIndex(variationItem => {
        if (variationItem.variationId === variation.variationId) {
          return true;
        }
        return false;
      });

      if (variationIndex === -1) {
        if (qty > 0) {
          this.variationsToBuy.push({
            variationId: variation.variationId,
            quantity: qty
          });
        }
      } else {
        this.variationsToBuy[variationIndex].quantity = qty;
      }
    },

    addToBasket () {
      this.addBasketItems(this.variationsToBuy)
        .then(
          response => {
            document.dispatchEvent(new CustomEvent('matrixAddToBasketEnded', {}));
          },
          error => {
            document.dispatchEvent(new CustomEvent('matrixAddToBasketEnded', {}));
            if (error.data) {
              error.data.exceptions.forEach((errorData) => {
                NotificationService.error(
                                    `<b>(Art.-ID: ${errorData.variationId}): </b>` +
                                    this.$translate(
                                      'Ceres::Template.' + ExceptionMap.get(errorData.exceptionCode.toString()),
                                      errorData.placeholder
                                    )
                ).closeAfter(15000);
              });
            }
          });
    },

    addBasketItems (items) {
      return new Promise((resolve, reject) => {
        window.ceresStore.commit('setIsBasketLoading', true);

        const request = {
          template: 'Ceres::Basket.Basket',
          items: items
        };

        ApiService.post('/rest/matrixbasket/items/', request)
          .done(response => {
            window.ceresStore.commit('setIsBasketLoading', false);
            resolve(response);
          })
          .fail(error => {
            window.ceresStore.commit('setIsBasketLoading', false);
            reject(error);
          });
      });
    }
  }
};
</script>
